import React from "react";
import { Link } from "react-router-dom";
import '../styles/Breadcrumbs.css';

const Breadcrumbs = ({ category, subcategory, productName }) => {
  return (
    <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>

        {category && (
          <li className="breadcrumb-item">
            <Link to={category.link}>{category.name}</Link>
          </li>
        )}

        {subcategory && (
          <li className="breadcrumb-item">
            <Link to={subcategory.link}>{subcategory.name}</Link>
          </li>
        )}

        {productName && (
          <li className="breadcrumb-item active" aria-current="page">
            {productName}
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;